import { config } from '../../utils/config'

export async function getReportingHotelGroups(token?: string | null) {
  const url = new URL(`${config.publicRuntimeConfig.humpclubRoot}/reporting/v2/hotel-groups`)

  const response = await fetch(url.toString(), {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  })

  if (!response.ok) {
    throw new Error(`Hotel groups request failed (${response.status})`)
  }
  return response.json() as Promise<string[]>
}
